import api from '../lib/api';

class BitdefenderService {
  async getEndpoints(assetId) {
    try {
      const params = {};
      if (assetId) {
        params.asset_id = assetId;
      }
      const response = await api.get('/bitdefender/endpoints', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching endpoints:', error);
      throw error;
    }
  }

  async getEndpointStatus(endpointId) {
    try {
      const response = await api.get(`/bitdefender/endpoints/${endpointId}/status`);
      return response.data;
    } catch (error) {
      console.error('Error fetching endpoint status:', error);
      throw error;
    }
  }

  async triggerScan(endpointId, scanType = 1) {
    try {
      const response = await api.post(
        `/bitdefender/endpoints/${endpointId}/scan`,
        {},
        { params: { scan_type: scanType } }
      );
      return response.data;
    } catch (error) {
      console.error('Error triggering scan:', error);
      throw error;
    }
  }

  async syncEndpoints() {
    try {
      const response = await api.post('/bitdefender/sync-endpoints');
      return response.data;
    } catch (error) {
      console.error('Error syncing endpoints:', error);
      throw error;
    }
  }

  async getIncidents(endpointId, assetId) {
    try {
      const params = {};
      if (endpointId) params.endpoint_id = endpointId;
      if (assetId) params.asset_id = assetId;
      
      const response = await api.get('/bitdefender/incidents', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching incidents:', error);
      throw error;
    }
  }


  async getUnprotectedAssets() {
    try {
      const response = await api.get('/bitdefender/unprotected-assets');
      return response.data;
    } catch (error) {
      console.error('Error fetching unprotected assets:', error);
      throw error;
    }
  }


  async getAssetEndpoint(assetId) {
    try {
      const response = await api.get(`/bitdefender/asset/${assetId}/endpoint`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset endpoint:', error);
      throw error;
    }
  }
}

export default new BitdefenderService();
